import React from 'react'
import Sidebar from '../../../Sidebar'
import Navbar from '../../../Navbar'

const ResultAvailable = () => {
  return (
    <>
      <Sidebar/>
        <div className="main">
          <div className="topbar">
            <Navbar title="Election Result Availabble"/>
          </div>
        </div>
    </>
  )
}

export default ResultAvailable
